import { personasData } from "../utils/personas/personas";

export function mapPersonas(personasIds: any) {
  const firstLevel: any = [];
  const secondLevel: any = [];

  for (let i = 0; i < personasIds.length; i++) {
    const personaId = personasIds[i].personaId;
    const childrenIds = personasIds[i].childrenPersonaIds;

    for (let i = 0; i < personasData.length; i++) {
      if (personasData[i].id === personaId) {
        firstLevel.push(personasData[i].name);
        const categories = personasData[i].categories;

        for (let i = 0; i < categories.length; i++) {
          if (childrenIds.includes(categories[i].id)) {
            secondLevel.push(categories[i].name);
          }
        }
      }
    }
  }

  return {
    personas: firstLevel,
    children: secondLevel
  }
}
